// @flow
import React from 'react';

import { withTranslation } from 'react-i18next';

import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import makeComponentTrashable from 'trashable-react';
import {
  ListItemIcon,
  ListItem,
  List,
  ListItemText,
  Avatar,
  ListSubheader,
  Fab,
} from '@material-ui/core';
import Loading from '../../components/Loading';
import TimeDisplay from './TimeDisplay';
import { BackendBadge, getBadge } from './BackendBadge';
import ScribeTranscript from './ScribeTranscript';
import { getTranscriptHtmlFromData } from '../../actions/transcript';

type State = {
  selected?: string,
};

type Props = {
  conversations: Array<Object>,
  theme: Object,
  loading: boolean,
  backends: Array<Object>,
  t: Function,
  handleNewRoomStatus: Function,
  fetchTranscripts: Function,
  fontSize: number,
};

// eslint-disable-next-line
class ScribeConversations extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  download() {
    const { selected } = this.state;
    const { conversations } = this.props;
    const convo = conversations.find(c => c.id === selected);
    if (!convo) return;
    const trObject = {};
    const sObject = {};
    let lt = {};
    convo.transcripts.forEach(t => {
      trObject[t.id] = {
        ...t,
        texts: t.text,
        author: t.speakerId,
        authorShow: t.speakerId !== lt.speakerId,
      };
      if (t.text && t.speechLang && t.text[t.speechLang.split('-')[0]]) lt = t;
    });
    convo.speakers.forEach(s => {
      sObject[s.avaId] = s;
    });

    getTranscriptHtmlFromData(trObject, sObject, '~', convo.room, false);
  }

  render() {
    const {
      conversations,
      loading,
      backends,
      fetchTranscripts,
      t,
      fontSize,
      theme,
      handleNewRoomStatus,
    } = this.props;
    const { selected } = this.state;
    if (loading) return <Loading />;
    if (selected) {
      const convo = conversations.find(c => c.id === selected);
      const speakers = [];
      const fabStyle = {
        position: 'fixed',
        right: 20,
        backgroundColor: theme.palette.ava.blue,
        color: 'white',
      };
      if (convo) {
        convo.speakers.forEach(s => {
          speakers[s.avaId] = { ...s, userAvatar: s.photoUrl };
        });
        let lt = {};
        return (
          <div style={{ marginRight: 10, marginLeft: 20 }}>
            <div style={{ height: 67, minHeight: 67 }} />
            <Fab
              color="secondary"
              style={{
                ...fabStyle,
                top: 80,
              }}
              onClick={() => {
                handleNewRoomStatus({}, true);
                this.setState({ selected: '' });
              }}
            >
              <Close />
            </Fab>
            <Fab
              color="secondary"
              style={{
                ...fabStyle,
                top: 150,
              }}
              onClick={() => this.download()}
            >
              <i className="material-icons">save_alt</i>
            </Fab>
            {(convo.transcripts || []).map(tr => {
              const c = (
                <ScribeTranscript
                  key={tr.id}
                  author={tr.speakerId}
                  authorShow={tr.speakerId !== lt.speakerId}
                  currentPlatform="web"
                  id={tr.id}
                  isSelected={false}
                  lang="~"
                  muted
                  socketConnected
                  speakers={speakers}
                  texts={tr.text}
                  speechLang={tr.speechLang}
                  fontSize={fontSize}
                  user={{}}
                />
              );
              if (
                tr.text &&
                tr.speechLang &&
                tr.text[tr.speechLang.split('-')[0]]
              )
                lt = tr;
              return c;
            })}
          </div>
        );
      }
    }

    const timedConversations = {
      today: [],
      yesterday: [],
      lastWeek: [],
      lastMonth: [],
      older: [],
    };
    const BOD = new Date();
    BOD.setHours(0);
    BOD.setMinutes(0);
    BOD.setSeconds(0);
    const YBOD = new Date(BOD);
    YBOD.setDate(YBOD.getDate() - 1);
    const LWBOD = new Date(BOD);
    LWBOD.setDate(YBOD.getDate() - 6);
    const LMBOD = new Date(BOD);
    LMBOD.setDate(LMBOD.getDate() - 30);

    conversations.forEach(c => {
      if (c.speaker.t0 < LMBOD.getTime()) {
        timedConversations.older.push(c);
      } else if (c.speaker.t0 < LWBOD.getTime()) {
        timedConversations.lastMonth.push(c);
      } else if (c.speaker.t0 < YBOD.getTime()) {
        timedConversations.lastWeek.push(c);
      } else if (c.speaker.t0 < BOD.getTime()) {
        timedConversations.yesterday.push(c);
      } else {
        timedConversations.today.push(c);
      }
    });

    return (
      <>
        <div style={{ height: 67, minHeight: 67 }} />
        <div style={{ overflowY: 'scroll', height: 'calc(100vh - 70px)' }}>
          <List component="nav" aria-label="main mailbox folders">
            {['today', 'yesterday', 'lastWeek', 'lastMonth', 'older'].map(
              tt => (
                <li key={`section-${tt}`}>
                  <ul style={{ paddingInlineStart: 10 }}>
                    {timedConversations[tt].length > 0 && (
                      <ListSubheader
                        style={{
                          borderBottomStyle: 'solid',
                          borderWidth: 1,
                        }}
                      >
                        {t(`conversations.time.${tt}`)}
                      </ListSubheader>
                    )}
                    {timedConversations[tt]
                      .sort((c1, c2) => c2.speaker.t0 - c1.speaker.t0)
                      .filter(c => c.room.transcripts)
                      .filter(c => !c.id.includes('000000'))
                      .map(c => (
                        <ListItem
                          key={c.id}
                          button
                          onClick={() => {
                            this.setState({ selected: c.id });
                            handleNewRoomStatus({
                              ...c.room,
                              id: c.id,
                              past: true,
                              transcriptOwners: c.speakers.map(s => s.avaId),
                              speakers: c.speakers,
                            });
                            fetchTranscripts(c);
                          }}
                        >
                          <div
                            style={{
                              maxWidth: 150,
                              width: 150,
                              display: 'flex',
                              overflow: 'hidden',
                            }}
                          >
                            {c.speakers.map((s, ii) => (
                              <ListItemIcon key={`${c.id}-${s.avaId}`}>
                                <Avatar
                                  style={{
                                    marginLeft: ii > 0 ? -30 : undefined,
                                    borderStyle: 'solid',
                                    borderWidth: 1,
                                  }}
                                  src={s.photoUrl}
                                >
                                  {(s.userName || 'G')[0]}
                                </Avatar>
                              </ListItemIcon>
                            ))}
                          </div>
                          <ListItemText
                            style={{
                              maxWidth: 300,
                              minWidth: 200,
                            }}
                          >
                            {c.title}
                            {!c.title && (
                              <>
                                {c.speakers.length > 1 ? (
                                  <span>
                                    {t('conversations.youAnd')}{' '}
                                    {c.speakers.length - 1}{' '}
                                    {t('conversations.others')}
                                  </span>
                                ) : (
                                  <span>{t('conversations.newNote')}</span>
                                )}
                              </>
                            )}
                            <span style={{ color: 'grey', fontSize: 14 }}>
                              {' '}
                              <TimeDisplay
                                ms={
                                  c.room.endTimestampMs -
                                  c.room.startTimestampMs
                                }
                              />
                            </span>
                            <br />
                            {new Date(c.room.startTimestampMs).toLocaleString()}
                          </ListItemText>
                          <div style={{ minWidth: 80, width: 80, maxWith: 80 }}>
                            {c.room.env !== 'production' && (
                              <BackendBadge
                                style={{
                                  color: 'white',
                                  width: 'fit-content',
                                  backgroundColor: getBadge(
                                    backends,
                                    'web',
                                    c.room.env
                                  ).backgroundColor,
                                  margin: 'auto',
                                }}
                              >
                                {getBadge(backends, 'web', c.room.env).name}
                              </BackendBadge>
                            )}
                          </div>
                        </ListItem>
                      ))}
                  </ul>
                </li>
              )
            )}
          </List>
        </div>
      </>
    );
  }
}

// $FlowFixMe
export default withRouter(
  withTranslation()(
    withTheme(makeComponentTrashable(withTranslation()(ScribeConversations)))
  )
);
